module.exports = __webpack_public_path__ + "assets/images/05.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/05.png
// module id = 1258
// module chunks = 1